import { SET_COUNTER_AIRLINES } from '../actions/actionTypes';

const initialState: any = [];

export const airlinesCounterReducer = (state: any = initialState, action: any) => {

  switch (action.type) {

    case SET_COUNTER_AIRLINES:
      return action.data;
    default:
      return state;
  }
};